import { axiosInstance } from "../../../utils/axios_config"

export default function IntegrationJobCycleService() {
    this.getRecords = async (reqBody) => {
        return axiosInstance.post('JobCycle', reqBody);
    }
}